import {RolesOrDefault} from 'shared/models';

export const getSettingByRole = <U>(settings: { [key in RolesOrDefault]: U }, role: RolesOrDefault) => {
    return (role in settings) ? settings[role] : settings.default;
};